import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import DragDrop from 'components/atoms/CustomSVGIcon/DragDrop';
import { CardEditable } from 'components/molecules/Card';
import { joinString } from 'utils/string';

const DraggableDataCard = ({ data, index, onChange, onClose }) => (
	<CardEditable
		text={data.description}
		header={
			<>
				<Box sx={{ fontSize: '15px', pt: 0.5 }}>
					<DragDrop />
				</Box>
				<Typography noWrap>{joinString(' ', [index + 1, data.key])}</Typography>
			</>
		}
		type={data.changeType === 'NEW' ? 'error' : 'info'}
		onChange={onChange}
		onClose={onClose}
		maxLength={50}
	/>
);

DraggableDataCard.propTypes = {
	data: PropTypes.object,
	index: PropTypes.number,
	onChange: PropTypes.func,
	onClose: PropTypes.func,
};

export default DraggableDataCard;
